<template>
	<div class="pcon">
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<div class="listBox f-bct">
					<div class="smallBox">
						<!-- 选项卡 -->
						<div class="navBox f-bct">
							<p class="a">Детали поездки</p>
							<p @click="back()">Вернуться</p>
						</div>
						<!-- 车次详情 -->
						<div class="bigBagMsg">
							<div class="tit f-bct">
								<div class="tl1">
									<div class="bor"></div>
									<p>Детали поездки</p>
								</div>
								<div class="tr1" v-if="pmsg.status == 0">Ожидает отправления</div>
								<div class="tr1" v-if="pmsg.status == 2">Отправлено</div>
								<div class="tr1" v-if="pmsg.status == 3">Доставлено</div>
							</div>
							<div class="bagDetail1 f-bct">
								<div class="bagCar1">
									<div class="bagCarItm">
										<p class="t1">Номер поезда<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.trainNumber}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Отправитель<span>：</span></p>
										<div class="t2">
											<el-image v-if="pmsg.packerPortrait" :src="pmsg.packerPortrait"></el-image>
											<el-image v-else :src="require('@/static/uzw.png')"></el-image>
											<p>{{pmsg.packerName}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Предполагаемое время отправления<span>：</span></p>
										<div class="t2">
											<p style="text-align: right;">{{pmsg.predictSendTime}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Предполагаемое время прибытия<span>：</span></p>
										<div class="t2">
											<p >{{pmsg.predictArriveTime}}</p>
										</div>
									</div>
								</div>
								<div class="bagCar1">
									<div class="bagCarItm">
										<p class="t1">Количество посылок<span>：</span></p>
										<div class="t2">
											<p>{{packageBigList.length}}шт</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Место назначения<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.destination}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Время отправления<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.sendTime}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 包裹列表 -->
						<div class="smallListTit f-bct">
							<div class="tl1">
								<div class="bor"></div>
								<p>Список посылок</p>
							</div>
							<div class="tr1 f-ct" @click="isop1 = !isop1">
								<p>Развернуть/Свернуть</p>
								<el-image :src="require('@/static/icon31.png')"></el-image>
							</div>
						</div>
						<div class="smallList" v-if="isop1">
							<div class="itm" v-for="(item,index) in packageBigList">
								<div class="sn f-bct">
									<div class="t1 f-ct">
										Трек-номер：<span>{{item.bigExpressNumber}}</span>
									</div>
									<div class="t2" v-if="item.status == 2">Ожидает упаковки</div>
									<div class="t2" v-if="item.status == 3">Упаковано</div>
									<div class="t2" v-if="item.status == 4">Отправлено</div>
									<div class="t2" v-if="item.status == 5">Доставлено</div>
								</div>
								<div class="detail f-ct">
									<div class="msg f-ct">
										<el-image class="img" @click="showImgViewer(item.gallery)" v-if="item.gallery.length" :src="item.gallery[0]"></el-image>
										<el-image class="img" v-else :src="require('@/static/img4.png')"></el-image>
										<div class="r f-ct">
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon17.png')"></el-image>
													<p>Длина：{{item.length||'？'}}cm</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon18.png')"></el-image>
													<p>Ширина：{{item.width||'？'}}cm</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon19.png')"></el-image>
													<p>Высота：{{item.height||'？'}}cm</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon32.png')"></el-image>
													<p>Плотность：{{item.density||'？'}}KG/m³</p>
												</div>
											</div>
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon20.png')"></el-image>
													<p>Объем：{{item.volume||'？'}}cm³</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon21.png')"></el-image>
													<p>Вес：{{item.weight||'？'}}kg</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon22.png')"></el-image>
													<p>Количество：{{item.miniPackageNum||'？'}}шт</p>
												</div>
											</div>
										</div>
									</div>
									<div class="bor"></div>
									<div class="caozuo">
										<p class="t1" @click="link('/bigBagMsg',{id:item.id})">Подробнее</p>
									</div>
								</div>
							</div>
						</div>
						<!-- 车次途径点：20 -->
						<div class="smallListTit f-bct">
							<div class="tl1">
								<div class="bor"></div>
								<p>Пункты маршрута：{{trainStationList.length}}</p>
							</div>
							<div class="tr1 f-ct" @click="isop2 = !isop2">
								<p>Развернуть/Свернуть</p>
								<el-image :src="require('@/static/icon31.png')"></el-image>
							</div>
						</div>
						<div class="carStatusList" v-if="isop2">
							<div class="wlStatus">

								<!-- <div class="itm flex">
									<div class="l"></div>
									<div class="r">
										<div class="t2">2025-06-11 15:00:22</div>
										<div class="t1">您的包裹已到达【杭州拱墅大浒网点】，准备分配派配派送员</div>
									</div>
								</div> -->

								<div class="itm flex" v-for="(item,index) in trainStationList">
									<div class="l"></div>
									<div class="r">
										<div class="t2">{{item.createTime}}</div>
										<div class="t1" v-if="index==0">Прибытие：【{{item.stationName}}】</div>
										<div class="t3" v-else>Прибытие：【{{item.stationName}}】</div>
									</div>
								</div>

							</div>
						</div>
						<!--  -->
					</div>
				</div>
			</div>
		</div>
		<!-- 图片预览 -->
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
	</div>
</template>
<script>
	import { trainDetail } from "/src/api/api.js"
	import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
	export default {
		components: {
			'leftBox': () => import('@/components/leftBox.vue'),
			'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
		},
		data(){
			return {
				imgViewerVisible:false,
				imgList:[],

				id:0,
				pmsg:'',
				packageBigList:[],
				trainStationList:[],
				isop1:true,
				isop2:true,
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.trainDetail()
		},
		methods:{
			// 图预览
			showImgViewer(arr){
				this.imgList = arr
				this.imgViewerVisible = true;
				const m = (e) => { e.preventDefault() };
			},
			closeImgViewer(){
				this.imgViewerVisible = false;
			},
			async trainDetail(){
				const res = await trainDetail({id:this.id})
				if(res.code==200){
					this.pmsg = res.data
					this.packageBigList = res.data.packageBigList
					this.trainStationList = res.data.trainStationList
				}else{this.Tips(res.msg);}
			},
		},
		computed:{
			...mapState('userMsg',['userInfo']),
		}
	}
</script>
<style lang="scss">
	body{
		// background: #f6f7fb;
	}
</style>
<style lang="scss" scoped>
	.pcon{
		padding: 0 74px;
		padding-bottom: 46px;
	}
	.banner{
		width: 100%;
		height: 413px;
		.el-image{
			width: 100%;
			height: 413px;
			border-radius: 18px;
		}
		.dian{
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			bottom: 16px;
			z-index: 2;
			div{
				margin: 0 3px;
				width: 8px;
				height: 8px;
				border-radius: 8px;
				background: #00000033;
				transition:0.3s;
			}
			.a{
				background: #fff;
				width: 14px;
				transition:0.3s;
			}
		}
	}
	.delBag{
		width: 140px;
		height: 42px;
		border: 1px solid #DDDDDD;
		font-size: 16px;
		color: #666666;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
		border-radius: 6px;
		background: #FF4D5A;
		border: 1px solid #FF4D5A;
		color: #fff;
		// margin-right: 12px;
		margin-top: 12px;
		margin-left: 1020px;
	}
	.pageCon{
		margin-top: 32px;
		justify-content: space-between;
		.pageConL{
			width: 530px;
		}
		.pageConR{
			width: calc(100% - 562px);
			.userNub{
				.itm{
					width: 382px;
					height: 158px;
					border-radius: 12px;
					background: #fff;
					padding-right: 46px;
					padding-left: 36px;
					.el-image{
						width: 80px;
					}
					.txt{
						width: calc(100% - 90px);
						margin-right: 10px;
						.t1{
							font-size: 42px;
							font-weight: bold;
						}
						.t2{
							font-size: 20px;
							color: #666666;
						}
					}
				}
			}
			.listBox{
				.tit{
					.tl{
						display: flex;
						align-items: center;
						.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
						p{
							font-size: 18px;
							padding-left: 10px;
						}
					}
					.tr{
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
						}
						p{
							font-size: 16px;
							color: #666666;
						}
					}
				}
				.zw{
					padding-top: 0;
					.el-image{
						margin-bottom: 0;
					}
				}
				.smallBox{
					width: 100%;
					// height: 411px;
					background: #fff;
					border-radius: 12px;
					padding: 24px;
					.smallList{
						margin-top: 16px;
						// height: 340px;
						// background: pink;
						// overflow: scroll;
						.itm{
							border: 1px solid #EFF1F6;
							border-radius: 8rpx;
							margin-bottom: 16px;
							.sn{
								height: 56px;
								border-bottom: 1px solid #EFF1F6;
								background: #EFF1F6;
								padding: 0 24px;
								.el-image{
									display: block;
									width: 20px;
									margin-right: 12px;
									// margin-left: 24px;
								}
								.t1{
									font-size: 16px;
									color: #999999;
									span{
										color: #333;
									}
								}
								.t3{
									.snTxt{
										font-size: 16px;
										color: #999999;
										span{
											color: #333;
										}
									}
									.bor{
										width: 1px;
										height: 16px;
										background: #D9D9D9;
										margin: 0 24px;
									}
									.man{
										font-size: 16px;
									}
								}
								.t2{
									padding: 0 6px;
									// width: 72px;
									height: 30px;
									background: #C7F3F5;
									font-size: 14px;
									color: #38ABB0;
									text-align: center;
									line-height: 30px;
									border-radius: 4px;
								}
							}
							.detail{
								padding: 16px 0;
								.msg{
									width: calc(100% - 105px);
									padding-left: 24px;
									// background: pink;
									.img{
										width: 66px;
										height: 66px;
										border-radius: 6px;
										margin-right: 16px;
									}
									.r{
										width: calc(100% - 82px);
										.cBox{
											margin-bottom: 10px;
											&:last-child{
												margin-bottom: 0;
											}
										}
										.nubitm{
											display: flex;
											align-items: center;
											// margin-right: 63px;
											width: 176px;
											.el-image{
												width: 20px;
												height: 20px;
												margin-right: 6px;
											}
											p{
												font-size: 16px;
											}
										}
									}
								}
								.bor{
									width: 1px;
									height: 50px;
									background: #D9D9D9;
								}
								.caozuo{
									width: 104px;
									// background: #00000033;
									p{
										text-align: center;font-size: 16px;
										cursor: pointer;
									}
									.t1{
										color: #38ABB0;
									}
									.t2{
										color: #FF4D5A;
										margin-top: 6px;
									}
									.t3{
										color: #38ABB0;
										margin-top: 6px;
									}
								}
							}
						}
					}
				}
				.mtBox{
					width: 382px;
					height: 411px;
					background: #fff;
					border-radius: 12px;
					padding: 24px;
					.maitouList{
						margin-top: 16px;
						height: 330px;
						// background: pink;
						overflow: scroll;
						.mtItm{
							margin-bottom: 22px;
							.l{
								.nub{
									// width: 20px;
									height: 20px;
									background: #38ABB0;
									margin-right: 12px;
									color: #fff;
									border-radius: 20px;
									font-size: 13px;
									text-align: center;
									line-height: 19px;
									padding: 0 5px;
									padding-left: 6px;
								}
								.el-image{
									width: 45px;
								}
								p{
									font-size: 16px;
									padding-left: 6px;
								}
							}
							.r{
								display: flex;
								align-items: center;justify-content: flex-end;
								.bor{
									width: 1px;
									height: 16px;
									margin: 0 10px;
									background: #D9D9D9;
								}
								.btnItm{
									display: flex;
									align-items: center;
									.el-image{
										width: 14px;
										margin-right: 4px;
									}
									p{
										font-size: 14px;
									}
									.t1{
										color: #38ABB0;
									}
									.t2{
										color: #FF4D5A;
									}
								}
							}
						}
					}
					.tableImgList{
						margin-top: 16px;
						height: 340px;
						// background: pink;
						overflow: scroll;
						.el-image{
							width: 100%;
							height: 154px;
							margin-bottom: 16px;
							border-radius: 12px;
						}
					}
				}
			}
		}
	}
	.shaixuan{
		padding: 0 24px;
		padding-top: 24px;
		margin-bottom: 24px;
		padding-left: 0;
		.l{
			.itm{
				display: flex;
				align-items: center;
				font-size: 16px;
				margin-right: 31px;
				span{
					display: block;
					width: 90px;
					padding-right: 16px;
				}
			}
			.itm1{
				display: flex;
				align-items: center;
				font-size: 16px;
				margin-right: 31px;
				border: 1px solid #DDDDDD;
				border-radius: 4px;
				span{
					display: block;
					width: 90px;
					padding-right: 16px;
				}
				::v-deep .el-input__inner{
					background: none;
					border: none;
					padding-left: 0;
				}
				.el-image{
					display: block;
					width: 16px;
					margin-left: 16px;
					margin-right: 12px;
				}
			}
		}
		.seachBtn{
			transform: translateX(-12px);
			div{
				width: 85px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				border-radius: 6px;
				&:first-child{
					background: #38ABB0;
					border: 1px solid #38ABB0;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
	}
	.rukuSel{
		.l{
			.el-image{
				width: 20px;
				margin-right: 12px;
			}
			span{
				font-size: 14px;
			}
		}
		.seachBtn{
			p{
				font-size: 14px;
				padding-right: 16px;
			}
			div{
				width: 128px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				border-radius: 6px;
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
	.navBox{
		border-bottom: 1px solid #EEEEEE;
		// padding: 0 10px;
		p{
			// padding-top: 24px;
			padding-bottom: 16px;
			// margin-right: 56px;
			font-size: 18px;
			cursor: pointer;
			color: #7D7D89;
			&::after{
				position: absolute;
				content: '';
				width: 0%;
				height: 4px;
				border-radius: 4px;
				background: #38ABB0;
				bottom: 0%;
				left: 50%;
				transform: translateX(-50%);
				transition:0.3s;
			}
		}
		.a{
			color: #38ABB0;
			font-weight: bold;
			&::after{
				width: 100%;
				transition:0.3s;
			}
		}
	}
	.smallListTit{
		margin-top: 24px;
		margin-bottom: 24px;
		.tl1{
			display: flex;
			align-items: center;
			.bor{
				width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;
			}
			p{
				font-size: 18px;
				padding-left: 24px;
				font-weight: bold;
			}
		}
		.tr1{
			cursor: pointer;
			.el-image{
				width: 20px;
				margin-left: 8px;
			}
			p{
				font-size: 16px;
				color: #38ABB0;
			}
		}
	}
	.bigBagMsg{
		margin-top: 24px;
		border-radius: 10px;
		border: 1px solid #EEEEEE;
		padding-top: 24px;
		padding-bottom: 36px;
		.tit{
			padding-bottom: 20px;
			padding-right: 18px;
			.tl1{
				display: flex;
				align-items: center;
				.bor{
					width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;
				}
				p{
					font-size: 18px;
					padding-left: 24px;
					font-weight: bold;
				}
			}
			.tr1{
				padding: 0 6px;
				// width: 72px;
				height: 30px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 28px;
				cursor: pointer;
				border-radius: 4px;
				background: #C7F3F5;
				border: 1px solid #C7F3F5;
				color: #38ABB0;
				margin-right: 12px;
			}
			.tr{
				display: flex;
				align-items: center;
				.el-image{
					width: 20px;
				}
				p{
					font-size: 16px;
					color: #666666;
				}
			}
		}
		.bagDetail{
			.bagimg{
				width: 572px;
				border-right: 1px solid #EBEEF5;
				padding-left: 24px;
				.el-image{
					width: 182px;
					height: 182px;
					border-radius: 6px;
					margin-right: 20px;
				}
				.bagimgR{
					width: calc(100% - 202px);
					.nubitm{
						display: flex;
						align-items: center;
						// margin-right: 63px;
						width: 164px;
						margin-bottom: 15px;
						.el-image{
							width: 20px;
							height: 20px;
							margin-right: 6px;
						}
						p{
							font-size: 16px;
						}
					}
					.anniu{
						width: 108px;
						height: 42px;
						border: 1px solid #DDDDDD;
						font-size: 16px;
						color: #666666;
						text-align: center;
						line-height: 38px;
						cursor: pointer;
						border-radius: 6px;
						background: #38ABB0;
						border: 1px solid #38ABB0;
						color: #fff;
						margin-right: 12px;
					}
				}
			}
			.bagCar{
				padding-left: 48px;
				width: calc(100% - 572px);
				// background: pink;
				padding-right: 30px;
				.bagCarItm{
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 100%;
					margin-bottom: 10px;
					// background: pink;
					.t1{
						position: relative;
						font-size: 16px;
						// span{
						// 	position: absolute;
						// }
					}
					.t2{
						font-size: 16px;
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
							height: 20px;
							border-radius: 50%;
							margin-right: 6px;
						}
					}
				}
			}
		}
		.bagDetail1{
			margin: 0 28px;
			border-top: 1px solid #DDDDDD;
			padding-top: 28px;
			.bagCar1{
				// width: 50%;
				width: 495px;
				// padding-left: 48px;
				// width: calc(100% - 572px);
				// background: pink;
				// padding-right: 30px;
				.bagCarItm{
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 100%;
					margin-bottom: 12px;
					// background: pink;
					.t1{
						position: relative;
						font-size: 16px;
						// span{
						// 	position: absolute;
						// }
					}
					.t2{
						font-size: 16px;
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
							height: 20px;
							border-radius: 50%;
							margin-right: 6px;
						}
					}
				}
			}
		}
	}
	.carStatusList{
		border: 1px solid #EEEEEE;
		border-radius: 10px;
		padding: 30px;
		.wlStatus{
			// width: 662px;
			margin: auto;
			background: #FFFFFF;
			border-radius: 0 0 16px 16px;
			// padding: 0 32px;
			// padding-top: 44px;
			padding-bottom: 2px;
			height: 480px;
			overflow: scroll;
			padding-left: 3px;
			.itm{
				border-left: 1px dashed #B8BAC1;
				margin-left: 5px;
				padding-bottom: 20px;
				&:first-child{
					margin-top: 0;
				}
				&:last-child{
					border-left: 2px dashed #fff;
				}
				.l{
					height: 12px;
					width: 12px;
					border-radius: 50%;
					background: #38ABB0;
					margin-right: 0px;
					transform: translateX(-6px);
				}
				.r{
					padding-left: 35px;
					transform: translateY(-4px);
					.t1{
						color: #2F3541;
						font-size: 16px;
						// margin-top: -2px;
						margin-top: 10px;
					}
					.t2{
						font-size: 14px;
						color: #9A9DA7;
						// margin-top: 10px;
					}
					.t3{
						color: #9A9DA7;
						font-size: 16px;
						// margin-top: -2px;
						margin-top: 10px;
					}
					.anniu{
						width: 176px;
						height: 72px;
						line-height: 72px;
						font-size: 24px;
						margin: 0;
						margin-top: 12px;
						letter-spacing: normal;
					}
					.red{
						background: #F26161;
					}
					.org{
						background: #E86F26;
					}
					.redT{
						color: #F26161;
					}
					.blueT{
						color: #3B6492;
					}
				}
			}
		}
	}
</style>